//import img1 from '../../images/svg-1.svg'
//import img2 from '../../images/svg-2.svg'
import HHD from '../../images/hiphip-dancing.jpg'
import RP from '../../images/record-player.jpg'

export const homeObjOne = 
{
    id: 'mission',
    topLine: 'Kickstart your music career',
    headLine: 'We are dedicated to helping you find artists to team up with.  Bringing people together is the soul of music, and we want to cherish that.',
    description: 'Sign up as a producer, lyricist, or both and start collaborating with artists on the platform!',
    alt: 'Guitarist',
    imgStart: true,
    img: HHD,
    buttonName: 'Learn More',
    to: 'services'   
}

export const homeObjTwo = 
{
    id: 'discover',
    topLine: 'Create your dream',
    headLine: 'We offer technology that connects you with people that can help you create your dream music!',
    description: 'Sync is made for artists',
    alt: 'link',
    imgStart: false,
    img: RP,
    buttonName: 'Register',
    to: 'home'
}


